import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { TextChunkSchema } from './text-chunks';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const TextChunkEmbeddingSchema = z.object({
  textChunkEmbeddingId: PrimaryKeySchema,
  textChunkId: TextChunkSchema.shape.textChunkId,
  embedding: z.array(z.number()),
  model: z.string(),
  createdAt: z.coerce.date(),
});

export type TextChunkEmbedding = z.infer<typeof TextChunkEmbeddingSchema>;

export const TextChunkEmbeddingsSchema = z.array(TextChunkEmbeddingSchema);

export type TextChunkEmbeddings = z.infer<typeof TextChunkEmbeddingsSchema>;

export const TextChunkEmbeddingsQuerySchema = z
  .object({
    textChunkEmbeddingIds: commaDelimitedList(
      TextChunkEmbeddingSchema.shape.textChunkEmbeddingId.array(),
    ).optional(),
    textChunkIds: commaDelimitedList(
      TextChunkSchema.shape.textChunkId.array(),
    ).optional(),
  })
  .merge(createOffsetPaginationRequestQuerySchema(z.enum(['createdAt'])));

export type TextChunkEmbeddingsQuery = z.infer<
  typeof TextChunkEmbeddingsQuerySchema
>;
